export enum ScreenName {
  ALL_ORDERS = "all-orders",
  PA_ORDERS = "pa-orders",
  DRAFTS = "drafts",
  PENDING_AUTHS = "pending-auths",
  IN_PROGRESS = "in-progress",
  APPROVED = "approved",
  DENIED = "denied",
  PARTIALLY_APPROVED = "partiallyApproved",
  CLOSED = "closed",
  PEER_TO_PEER = "peer-to-peer",
  APPEALS = "appeals",
  AUTH_NOT_REQUIRED = "auth-not-required",
  ELIGIBILITY_ERRORS = "eligibility-errors",
  PATIENT_ORDER = "patients",
}
